import InfoUser, { susaction, ploader } from './index';
//import CryptoDeposit from './Crypto';
//import Crypto from './Crypto';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import SiteError from '../error';
//import af from './style.module.scss';

function InfoPage() {
  return (
    <div>
      <div>
        <Outlet />
      </div>
    </div>
  );
}
//    { index: true, element: <AddFundsIndex /> },

export const susroutes = {
  path: `info`,
  //loader: mostrloader(apiContext),
  element: <InfoPage />,
  errorElement: <SiteError />,
  children: [
    { index: true, element: <InfoUser />,loader: ploader, },
    {
      path: 'notice',
      element: <InfoUser />,
      //action: vaaction,
      loader: ploader,
    }
    /*{, action: susaction
      path: 'crypto',
      element: <CryptoDeposit />,
      //loader: contactLoader,
    },*/
  ],
};
